(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');

const formatMoney = (cents, currency) => {
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency
    }).format(cents / 100);
  } catch {
    return (cents / 100).toFixed(2);
  }
};

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (!trigger) return;
  const panel = document.querySelector('[data-menu-panel]');
  if (!panel) return;
  const willOpen = panel.hidden;
  panel.hidden = !willOpen;
  document.body.classList.toggle('menu-open', willOpen);
  const hamburger = document.querySelector('.menu-toggle');
  if (hamburger) hamburger.setAttribute('aria-expanded', String(willOpen));
});

// Close the mobile menu when a navigation link inside it is tapped
document.addEventListener('click', (event) => {
  const link = event.target.closest('#MobileNavigation a');
  if (!link) return;
  const panel = document.querySelector('[data-menu-panel]');
  if (panel) panel.hidden = true;
  document.body.classList.remove('menu-open');
  const hamburger = document.querySelector('.menu-toggle');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const selector = form.querySelector('[name="id"]');
  const json = form.querySelector('[data-variants-json]');
  if (!selector || !json) return;
  const variants = JSON.parse(json.textContent);
  selector.addEventListener('change', () => {
    const variant = variants.find((item) => String(item.id) === selector.value);
    if (!variant) return;
    const price = form.querySelector('[data-product-price]');
    const compare = form.querySelector('[data-compare-price]');
    const button = form.querySelector('[name="add"]');
    if (price) price.textContent = formatMoney(variant.price, form.dataset.currency);
    if (compare) {
      compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price, form.dataset.currency) : '';
      compare.hidden = !variant.compare_at_price || variant.compare_at_price <= variant.price;
    }
    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldText;
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  });
});

if (document.documentElement.dataset.reveal === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));
} else {
  document.querySelectorAll('.reveal').forEach((element) => element.classList.add('is-visible'));
}
  } catch(e) { console.error(e); }
})();

})();
